/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CoverageAreaAudioMeteringFragment = {
	id: string;
	features: { peak: { level: number } | null; rms: { level: number } | null } | null;
};

export type ChannelMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { peak: { level: number } | null; rms: { level: number } | null; clip: { clip: boolean } | null } | null;
};

export type MatrixMixerOutputFragment = {
	id: string;
	isMatrixMixerOutputMeterChange: 'AudioChannelMeterChange';
	features: {
		matrixMixerOutputPeak: { level: number } | null;
		matrixMixerOutputRms: { level: number } | null;
	} | null;
};

export type MatrixMixerInputFragment = {
	id: string;
	isMatrixMixerInputMeterChange: 'AudioChannelMeterChange';
	features: { matrixMixerInputPeak: { level: number } | null; matrixMixerInputRms: { level: number } | null } | null;
};

export type MatrixMixerStereoInputFragment = {
	id: string;
	isMatrixMixerStereoInputMeterChange: 'AudioChannelMeterChange';
	features: {
		matrixMixerStereoInputPeak: { leftLevel: number; rightLevel: number } | null;
		matrixMixerStereoInputRms: { leftLevel: number; rightLevel: number } | null;
	} | null;
};

export type StereoChannelMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: {
		stereoPeak: { leftLevel: number; rightLevel: number } | null;
		stereoRms: { leftLevel: number; rightLevel: number } | null;
	} | null;
};

export type BoostCutMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { automaticGain: { gain: number } | null } | null;
};

export type CompressorEngagedFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { compressorEngaged: { engaged: boolean } | null } | null;
};

export type LimiterEngagedFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { limiterEngaged: { engaged: boolean } | null } | null;
};

export type AudioGateOnMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { automixerGate: { open: boolean } | null; stereoAutomixerGate: { open: boolean } | null } | null;
};

export type AutomixGainMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { automixGain: { gain: number } | null } | null;
};

export type StereoAutomixGainMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { stereoAutomixGain: { gain: number } | null } | null;
};

export type PostGateGainStereoMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: {
		postGateGainStereoPeak: { leftLevel: number; rightLevel: number } | null;
		postGateGainStereoRms: { leftLevel: number; rightLevel: number } | null;
	} | null;
};

export type AgcMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: {
		automaticGainControlPeak: { level: number } | null;
		automaticGainControlRms: { level: number } | null;
	} | null;
};

export type AecErleMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { acousticEchoCancellationErle: { level: number } | null } | null;
};

export type AcousticEchoCancellationFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: {
		acousticEchoCancellationRms: { level: number } | null;
		acousticEchoCancellationPeak: { level: number } | null;
	} | null;
};

export type DenoiserNrMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { denoiserNoiseReduction: { percentage: number } | null } | null;
};

export type AutomixerInputMeteringFragment = {
	id: string;
	isAudioChannelMeterChange: 'AudioChannelMeterChange';
	features: { automixerInputRms: { level: number } | null; automixerInputPeak: { level: number } | null } | null;
};

export type CoverageAreaAutomixerGateMeteringFragment = {
	id: string;
	isCoverageAreaMeterChange: 'AudioCoverageAreaMeterChange';
	features: { automixerGate: { open: boolean } | null } | null;
};

export type RfChannelMeteringFragment = {
	id: string;
	isRfChannelMeterChange: 'RfChannelMeterChange';
	features: { signalStrength: { antennas: Array<{ level: number }> } | null } | null;
};

export type MultiAntennaRfChannelMeteringFragment = {
	id: string;
	isMultiAntennaRfChannelMeterChange: 'RfChannelMeterChange';
	features: {
		antennaDiversity: {
			antennas: Array<{
				active: boolean;
				antenna: string;
				interference: Types.RfChannelInterferenceDetectionSeverity | null;
			}>;
		} | null;
		quality: { level: number | null } | null;
		signalStrength: { antennas: Array<{ antenna: string; level: number }> } | null;
	} | null;
};

export type ChannelAnalogStereoMeteringFragment = {
	id: string;
	isAudioChannelAnalogStereoMeterChange: 'AudioChannelMeterChange';
	features: {
		analogStereoPeak: { rightLevel: number; leftLevel: number } | null;
		analogStereoRms: { rightLevel: number; leftLevel: number } | null;
		clip: { clip: boolean } | null;
	} | null;
};

export type CoverageAreaAudioMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type CoverageAreaAudioMeteringSubscriptionOpResult = { meterChanges: CoverageAreaAudioMeteringFragment | {} };

export type ChannelMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type ChannelMeteringSubscriptionOpResult = { meterChanges: ChannelMeteringFragment | {} };

export type MatrixMixerOutputMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type MatrixMixerOutputMeteringSubscriptionOpResult = { meterChanges: MatrixMixerOutputFragment | {} };

export type MatrixMixerInputMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type MatrixMixerInputMeteringSubscriptionOpResult = { meterChanges: MatrixMixerInputFragment | {} };

export type MatrixMixerStereoInputMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type MatrixMixerStereoInputMeteringSubscriptionOpResult = { meterChanges: MatrixMixerStereoInputFragment | {} };

export type StereoChannelMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type StereoChannelMeteringSubscriptionOpResult = { meterChanges: StereoChannelMeteringFragment | {} };

export type BoostCutMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type BoostCutMeteringSubscriptionOpResult = { meterChanges: BoostCutMeteringFragment | {} };

export type CompressorEngagedSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type CompressorEngagedSubscriptionOpResult = { meterChanges: CompressorEngagedFragment | {} };

export type LimiterEngagedSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type LimiterEngagedSubscriptionOpResult = { meterChanges: LimiterEngagedFragment | {} };

export type AudioGateOnMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AudioGateOnMeteringSubscriptionOpResult = { meterChanges: AudioGateOnMeteringFragment | {} };

export type AutomixGainMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AutomixGainMeteringSubscriptionOpResult = { meterChanges: AutomixGainMeteringFragment | {} };

export type StereoAutomixGainMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type StereoAutomixGainMeteringSubscriptionOpResult = { meterChanges: StereoAutomixGainMeteringFragment | {} };

export type PostGateGainStereoMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type PostGateGainStereoMeteringSubscriptionOpResult = { meterChanges: PostGateGainStereoMeteringFragment | {} };

export type AgcMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AgcMeteringSubscriptionOpResult = { meterChanges: AgcMeteringFragment | {} };

export type AecErleMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AecErleMeteringSubscriptionOpResult = { meterChanges: AecErleMeteringFragment | {} };

export type AcousticEchoCancellationMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AcousticEchoCancellationMeteringSubscriptionOpResult = {
	meterChanges: AcousticEchoCancellationFragment | {};
};

export type DenoiserNrMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type DenoiserNrMeteringSubscriptionOpResult = { meterChanges: DenoiserNrMeteringFragment | {} };

export type AutomixerInputMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type AutomixerInputMeteringSubscriptionOpResult = { meterChanges: AutomixerInputMeteringFragment | {} };

export type CoverageAreaAutomixerGateMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type CoverageAreaAutomixerGateMeteringSubscriptionOpResult = {
	meterChanges: CoverageAreaAutomixerGateMeteringFragment | {};
};

export type RfChannelMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type RfChannelMeteringSubscriptionOpResult = { meterChanges: RfChannelMeteringFragment | {} };

export type MultiAntennaRfChannelMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type MultiAntennaRfChannelMeteringSubscriptionOpResult = {
	meterChanges: MultiAntennaRfChannelMeteringFragment | {};
};

export type ChannelAnalogStereoMeteringSubscriptionVariables = Types.Exact<{
	meterChangeId: Types.Scalars['ID']['input'];
	types: Array<Types.MeterChangeType> | Types.MeterChangeType;
	updateRate: Types.Scalars['Duration']['input'];
}>;

export type ChannelAnalogStereoMeteringSubscriptionOpResult = {
	meterChanges: ChannelAnalogStereoMeteringFragment | {};
};

export const CoverageAreaAudioMeteringFragment = gql`
	fragment CoverageAreaAudioMeteringFragment on AudioCoverageAreaMeterChange {
		id
		features {
			peak {
				level
			}
			rms {
				level
			}
		}
	}
`;
export const ChannelMeteringFragment = gql`
	fragment ChannelMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			peak {
				level
			}
			rms {
				level
			}
			clip {
				clip
			}
		}
	}
`;
export const MatrixMixerOutputFragment = gql`
	fragment MatrixMixerOutputFragment on AudioChannelMeterChange {
		isMatrixMixerOutputMeterChange: __typename
		id
		features {
			matrixMixerOutputPeak {
				level
			}
			matrixMixerOutputRms {
				level
			}
		}
	}
`;
export const MatrixMixerInputFragment = gql`
	fragment MatrixMixerInputFragment on AudioChannelMeterChange {
		isMatrixMixerInputMeterChange: __typename
		id
		features {
			matrixMixerInputPeak {
				level
			}
			matrixMixerInputRms {
				level
			}
		}
	}
`;
export const MatrixMixerStereoInputFragment = gql`
	fragment MatrixMixerStereoInputFragment on AudioChannelMeterChange {
		isMatrixMixerStereoInputMeterChange: __typename
		id
		features {
			matrixMixerStereoInputPeak {
				leftLevel
				rightLevel
			}
			matrixMixerStereoInputRms {
				leftLevel
				rightLevel
			}
		}
	}
`;
export const StereoChannelMeteringFragment = gql`
	fragment StereoChannelMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			stereoPeak {
				leftLevel
				rightLevel
			}
			stereoRms {
				leftLevel
				rightLevel
			}
		}
	}
`;
export const BoostCutMeteringFragment = gql`
	fragment BoostCutMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			automaticGain {
				gain
			}
		}
	}
`;
export const CompressorEngagedFragment = gql`
	fragment CompressorEngagedFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			compressorEngaged {
				engaged
			}
		}
	}
`;
export const LimiterEngagedFragment = gql`
	fragment LimiterEngagedFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			limiterEngaged {
				engaged
			}
		}
	}
`;
export const AudioGateOnMeteringFragment = gql`
	fragment AudioGateOnMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			automixerGate {
				open
			}
			stereoAutomixerGate {
				open
			}
		}
	}
`;
export const AutomixGainMeteringFragment = gql`
	fragment AutomixGainMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			automixGain {
				gain
			}
		}
	}
`;
export const StereoAutomixGainMeteringFragment = gql`
	fragment StereoAutomixGainMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			stereoAutomixGain {
				gain
			}
		}
	}
`;
export const PostGateGainStereoMeteringFragment = gql`
	fragment PostGateGainStereoMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			postGateGainStereoPeak {
				leftLevel
				rightLevel
			}
			postGateGainStereoRms {
				leftLevel
				rightLevel
			}
		}
	}
`;
export const AgcMeteringFragment = gql`
	fragment AgcMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			automaticGainControlPeak {
				level
			}
			automaticGainControlRms {
				level
			}
		}
	}
`;
export const AecErleMeteringFragment = gql`
	fragment AecErleMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			acousticEchoCancellationErle {
				level
			}
		}
	}
`;
export const AcousticEchoCancellationFragment = gql`
	fragment acousticEchoCancellationFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			acousticEchoCancellationRms {
				level
			}
			acousticEchoCancellationPeak {
				level
			}
		}
	}
`;
export const DenoiserNrMeteringFragment = gql`
	fragment DenoiserNRMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			denoiserNoiseReduction {
				percentage
			}
		}
	}
`;
export const AutomixerInputMeteringFragment = gql`
	fragment AutomixerInputMeteringFragment on AudioChannelMeterChange {
		isAudioChannelMeterChange: __typename
		id
		features {
			automixerInputRms {
				level
			}
			automixerInputPeak {
				level
			}
		}
	}
`;
export const CoverageAreaAutomixerGateMeteringFragment = gql`
	fragment CoverageAreaAutomixerGateMeteringFragment on AudioCoverageAreaMeterChange {
		isCoverageAreaMeterChange: __typename
		id
		features {
			automixerGate {
				open
			}
		}
	}
`;
export const RfChannelMeteringFragment = gql`
	fragment RfChannelMeteringFragment on RfChannelMeterChange {
		isRfChannelMeterChange: __typename
		id
		features {
			signalStrength {
				antennas {
					level
				}
			}
		}
	}
`;
export const MultiAntennaRfChannelMeteringFragment = gql`
	fragment MultiAntennaRfChannelMeteringFragment on RfChannelMeterChange {
		isMultiAntennaRfChannelMeterChange: __typename
		id
		features {
			antennaDiversity {
				antennas {
					active
					antenna
					interference
				}
			}
			quality {
				level
			}
			signalStrength {
				antennas {
					antenna
					level
				}
			}
		}
	}
`;
export const ChannelAnalogStereoMeteringFragment = gql`
	fragment ChannelAnalogStereoMeteringFragment on AudioChannelMeterChange {
		isAudioChannelAnalogStereoMeterChange: __typename
		id
		features {
			analogStereoPeak {
				rightLevel
				leftLevel
			}
			analogStereoRms {
				rightLevel
				leftLevel
			}
			clip {
				clip
			}
		}
	}
`;
export const CoverageAreaAudioMeteringSubscriptionDocument = gql`
	subscription CoverageAreaAudioMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...CoverageAreaAudioMeteringFragment
		}
	}
	${CoverageAreaAudioMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class CoverageAreaAudioMeteringSubscriptionGQL extends Apollo.Subscription<
	CoverageAreaAudioMeteringSubscriptionOpResult,
	CoverageAreaAudioMeteringSubscriptionVariables
> {
	override document = CoverageAreaAudioMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ChannelMeteringSubscriptionDocument = gql`
	subscription ChannelMeteringSubscription($meterChangeId: ID!, $types: [MeterChangeType!]!, $updateRate: Duration!) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...ChannelMeteringFragment
		}
	}
	${ChannelMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ChannelMeteringSubscriptionGQL extends Apollo.Subscription<
	ChannelMeteringSubscriptionOpResult,
	ChannelMeteringSubscriptionVariables
> {
	override document = ChannelMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const MatrixMixerOutputMeteringSubscriptionDocument = gql`
	subscription MatrixMixerOutputMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...MatrixMixerOutputFragment
		}
	}
	${MatrixMixerOutputFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class MatrixMixerOutputMeteringSubscriptionGQL extends Apollo.Subscription<
	MatrixMixerOutputMeteringSubscriptionOpResult,
	MatrixMixerOutputMeteringSubscriptionVariables
> {
	override document = MatrixMixerOutputMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const MatrixMixerInputMeteringSubscriptionDocument = gql`
	subscription MatrixMixerInputMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...MatrixMixerInputFragment
		}
	}
	${MatrixMixerInputFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class MatrixMixerInputMeteringSubscriptionGQL extends Apollo.Subscription<
	MatrixMixerInputMeteringSubscriptionOpResult,
	MatrixMixerInputMeteringSubscriptionVariables
> {
	override document = MatrixMixerInputMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const MatrixMixerStereoInputMeteringSubscriptionDocument = gql`
	subscription MatrixMixerStereoInputMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...MatrixMixerStereoInputFragment
		}
	}
	${MatrixMixerStereoInputFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class MatrixMixerStereoInputMeteringSubscriptionGQL extends Apollo.Subscription<
	MatrixMixerStereoInputMeteringSubscriptionOpResult,
	MatrixMixerStereoInputMeteringSubscriptionVariables
> {
	override document = MatrixMixerStereoInputMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const StereoChannelMeteringSubscriptionDocument = gql`
	subscription StereoChannelMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...StereoChannelMeteringFragment
		}
	}
	${StereoChannelMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class StereoChannelMeteringSubscriptionGQL extends Apollo.Subscription<
	StereoChannelMeteringSubscriptionOpResult,
	StereoChannelMeteringSubscriptionVariables
> {
	override document = StereoChannelMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const BoostCutMeteringSubscriptionDocument = gql`
	subscription BoostCutMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...BoostCutMeteringFragment
		}
	}
	${BoostCutMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class BoostCutMeteringSubscriptionGQL extends Apollo.Subscription<
	BoostCutMeteringSubscriptionOpResult,
	BoostCutMeteringSubscriptionVariables
> {
	override document = BoostCutMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CompressorEngagedSubscriptionDocument = gql`
	subscription CompressorEngagedSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...CompressorEngagedFragment
		}
	}
	${CompressorEngagedFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class CompressorEngagedSubscriptionGQL extends Apollo.Subscription<
	CompressorEngagedSubscriptionOpResult,
	CompressorEngagedSubscriptionVariables
> {
	override document = CompressorEngagedSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const LimiterEngagedSubscriptionDocument = gql`
	subscription LimiterEngagedSubscription($meterChangeId: ID!, $types: [MeterChangeType!]!, $updateRate: Duration!) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...LimiterEngagedFragment
		}
	}
	${LimiterEngagedFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class LimiterEngagedSubscriptionGQL extends Apollo.Subscription<
	LimiterEngagedSubscriptionOpResult,
	LimiterEngagedSubscriptionVariables
> {
	override document = LimiterEngagedSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AudioGateOnMeteringSubscriptionDocument = gql`
	subscription AudioGateOnMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...AudioGateOnMeteringFragment
		}
	}
	${AudioGateOnMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AudioGateOnMeteringSubscriptionGQL extends Apollo.Subscription<
	AudioGateOnMeteringSubscriptionOpResult,
	AudioGateOnMeteringSubscriptionVariables
> {
	override document = AudioGateOnMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AutomixGainMeteringSubscriptionDocument = gql`
	subscription AutomixGainMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...AutomixGainMeteringFragment
		}
	}
	${AutomixGainMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AutomixGainMeteringSubscriptionGQL extends Apollo.Subscription<
	AutomixGainMeteringSubscriptionOpResult,
	AutomixGainMeteringSubscriptionVariables
> {
	override document = AutomixGainMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const StereoAutomixGainMeteringSubscriptionDocument = gql`
	subscription StereoAutomixGainMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...StereoAutomixGainMeteringFragment
		}
	}
	${StereoAutomixGainMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class StereoAutomixGainMeteringSubscriptionGQL extends Apollo.Subscription<
	StereoAutomixGainMeteringSubscriptionOpResult,
	StereoAutomixGainMeteringSubscriptionVariables
> {
	override document = StereoAutomixGainMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const PostGateGainStereoMeteringSubscriptionDocument = gql`
	subscription PostGateGainStereoMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...PostGateGainStereoMeteringFragment
		}
	}
	${PostGateGainStereoMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class PostGateGainStereoMeteringSubscriptionGQL extends Apollo.Subscription<
	PostGateGainStereoMeteringSubscriptionOpResult,
	PostGateGainStereoMeteringSubscriptionVariables
> {
	override document = PostGateGainStereoMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AgcMeteringSubscriptionDocument = gql`
	subscription AgcMeteringSubscription($meterChangeId: ID!, $types: [MeterChangeType!]!, $updateRate: Duration!) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...AgcMeteringFragment
		}
	}
	${AgcMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AgcMeteringSubscriptionGQL extends Apollo.Subscription<
	AgcMeteringSubscriptionOpResult,
	AgcMeteringSubscriptionVariables
> {
	override document = AgcMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecErleMeteringSubscriptionDocument = gql`
	subscription AecErleMeteringSubscription($meterChangeId: ID!, $types: [MeterChangeType!]!, $updateRate: Duration!) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...AecErleMeteringFragment
		}
	}
	${AecErleMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AecErleMeteringSubscriptionGQL extends Apollo.Subscription<
	AecErleMeteringSubscriptionOpResult,
	AecErleMeteringSubscriptionVariables
> {
	override document = AecErleMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AcousticEchoCancellationMeteringSubscriptionDocument = gql`
	subscription AcousticEchoCancellationMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...acousticEchoCancellationFragment
		}
	}
	${AcousticEchoCancellationFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AcousticEchoCancellationMeteringSubscriptionGQL extends Apollo.Subscription<
	AcousticEchoCancellationMeteringSubscriptionOpResult,
	AcousticEchoCancellationMeteringSubscriptionVariables
> {
	override document = AcousticEchoCancellationMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DenoiserNrMeteringSubscriptionDocument = gql`
	subscription DenoiserNRMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...DenoiserNRMeteringFragment
		}
	}
	${DenoiserNrMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DenoiserNrMeteringSubscriptionGQL extends Apollo.Subscription<
	DenoiserNrMeteringSubscriptionOpResult,
	DenoiserNrMeteringSubscriptionVariables
> {
	override document = DenoiserNrMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AutomixerInputMeteringSubscriptionDocument = gql`
	subscription AutomixerInputMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...AutomixerInputMeteringFragment
		}
	}
	${AutomixerInputMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AutomixerInputMeteringSubscriptionGQL extends Apollo.Subscription<
	AutomixerInputMeteringSubscriptionOpResult,
	AutomixerInputMeteringSubscriptionVariables
> {
	override document = AutomixerInputMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CoverageAreaAutomixerGateMeteringSubscriptionDocument = gql`
	subscription CoverageAreaAutomixerGateMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...CoverageAreaAutomixerGateMeteringFragment
		}
	}
	${CoverageAreaAutomixerGateMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class CoverageAreaAutomixerGateMeteringSubscriptionGQL extends Apollo.Subscription<
	CoverageAreaAutomixerGateMeteringSubscriptionOpResult,
	CoverageAreaAutomixerGateMeteringSubscriptionVariables
> {
	override document = CoverageAreaAutomixerGateMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const RfChannelMeteringSubscriptionDocument = gql`
	subscription RfChannelMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...RfChannelMeteringFragment
		}
	}
	${RfChannelMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class RfChannelMeteringSubscriptionGQL extends Apollo.Subscription<
	RfChannelMeteringSubscriptionOpResult,
	RfChannelMeteringSubscriptionVariables
> {
	override document = RfChannelMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const MultiAntennaRfChannelMeteringSubscriptionDocument = gql`
	subscription MultiAntennaRfChannelMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...MultiAntennaRfChannelMeteringFragment
		}
	}
	${MultiAntennaRfChannelMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class MultiAntennaRfChannelMeteringSubscriptionGQL extends Apollo.Subscription<
	MultiAntennaRfChannelMeteringSubscriptionOpResult,
	MultiAntennaRfChannelMeteringSubscriptionVariables
> {
	override document = MultiAntennaRfChannelMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ChannelAnalogStereoMeteringSubscriptionDocument = gql`
	subscription ChannelAnalogStereoMeteringSubscription(
		$meterChangeId: ID!
		$types: [MeterChangeType!]!
		$updateRate: Duration!
	) {
		meterChanges(id: $meterChangeId, types: $types, updateRate: $updateRate) {
			...ChannelAnalogStereoMeteringFragment
		}
	}
	${ChannelAnalogStereoMeteringFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ChannelAnalogStereoMeteringSubscriptionGQL extends Apollo.Subscription<
	ChannelAnalogStereoMeteringSubscriptionOpResult,
	ChannelAnalogStereoMeteringSubscriptionVariables
> {
	override document = ChannelAnalogStereoMeteringSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
